import React from "react";
import { Box } from "@chakra-ui/react";
import Tooltip from "rc-tooltip";

type Props = {
	memberCount: number;
	maxStudents: number;
};

export function ClassroomStudentCount({ memberCount, maxStudents }: Props): JSX.Element {
	if (memberCount > maxStudents) {
		return (
			<Box zIndex="1">
				<Tooltip
					placement="top"
					trigger={["hover"]}
					destroyTooltipOnHide={true}
					overlayClassName="Tooltip"
					overlay={
						<Box>
							Exceeds max student limit.
							<br />
							Class cannot be started.
						</Box>
					}
				>
					<Box fontSize="14px" color="#A03B46">
						{memberCount} {memberCount === 1 ? "student" : "students"}
					</Box>
				</Tooltip>
			</Box>
		);
	}
	return (
		<Box fontSize="14px">
			{memberCount} {memberCount === 1 ? "student" : "students"}
		</Box>
	);
}
